/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, MITSUB_S){
	const a = 'is-active';
	const v = 'is-visible';
	const arrowPrev = '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg></button>';
	const arrowNext = '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></button>';
	let $path = location.pathname;

	// もっと見る
	const faqListMore = () => {
		const $faqList = $('.js-faqList li');
		if($faqList.length) {
			let startCnt = 0, endCnt = 10;
			const addResult = () => {
				for(let i=startCnt; i<endCnt; i++) {
					if($faqList.eq(i).length) {
						$faqList.eq(i).addClass(v);
						$('.js-faqList-more').addClass(v);
					} else {
						$('.js-faqList-more').remove();
						break;
					}
				}
			};
			// 最初の10件表示
			addResult();
			if($faqList.length <= 10) { $('.js-faqList-more').remove(); }
			// moreボタン押下で10件ずつ追加表示
			$('.js-faqList-more').on('click', () => {
				startCnt += 10; endCnt += 10;
				addResult();
			});
		}
	};

	// <よくあるご質問 > 「カテゴリから探す」カレント
	const faqCategoryCurrent = () => {
		$('.js-faq-category').each((idx, ele) => {
			let thisHref = $(ele).attr('href');
			if(thisHref === $path || thisHref +'index.html' === $path) {
				$(ele).addClass(a);
			}
		});
	};

	// <よくあるご質問> キーワード検索
	const keyWrodSearchResult = () => {
		let param = location.search.split('&');
		let thisKeyWord = '';
		for(let i = 0; i < param.length; i++) {
			if(param[i].indexOf('p_keyword') !== -1) {
				thisKeyWord = param[i].split('=')[1];
			}
		}
		$('.js-thisKeyword').text(decodeURI(thisKeyWord));
		$('.js-input-keyword').val(decodeURI(thisKeyWord))

		// タイトル
		let titleTxt = 'キーワード「'+ decodeURI(thisKeyWord) +'」の検索結果｜よくあるご質問｜お問い合わせ｜三菱食品株式会社';
		document.title = titleTxt;
		$('.js-meta-title').attr('content', titleTxt);
	};

	// ==============================================================================
	if($('.js-faqList-more')) {
		faqListMore();
	}
	if($('.js-faq-category')) {
		faqCategoryCurrent();
	}
	if($path === '/inquire/faq/search/result.html') {
		keyWrodSearchResult();
	}

})(window.jQuery, window.MITSUB_S);
